export const setFilters = ({ commit }, filters) => {
  commit('SET_FILTERS', filters)
}

export const updateURL = ({ commit, state }, filters) => {
  commit('SET_FILTERS', filters)

  const query = queryString.stringify(state.filters, { arrayFormat: 'bracket' })

  const newUrl = window.location.origin + window.location.pathname + '?' + query

  history.pushState({}, null, newUrl)
}
